var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "rounded-lg bg-white mt-2 mx-4 w-[calc(100%-2rem)]" },
    [
      _c(
        "van-form",
        {},
        [
          _vm.showAddress
            ? _c(
                "div",
                [
                  _c("van-field", {
                    staticClass: "px-3",
                    attrs: {
                      label: _vm.$t("address.country"),
                      placeholder: _vm.$t("address.countryPlaceholder"),
                      readonly: "",
                      "is-link": "",
                    },
                    on: { "click-input": _vm.handleCountryClick },
                    model: {
                      value: _vm.form.receiverCountry,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "receiverCountry", $$v)
                      },
                      expression: "form.receiverCountry",
                    },
                  }),
                  _c("van-field", {
                    staticClass: "px-3",
                    attrs: {
                      label: _vm.$t("address.city"),
                      placeholder: _vm.$t("address.cityPlaceholder"),
                      readonly: "",
                      "is-link": "",
                    },
                    on: { "click-input": _vm.handleCityClick },
                    model: {
                      value: _vm.form.receiverCity,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "receiverCity", $$v)
                      },
                      expression: "form.receiverCity",
                    },
                  }),
                  _c("van-field", {
                    staticClass: "px-3",
                    attrs: {
                      label: _vm.$t("address.zipCode"),
                      "label-width": "100px",
                      placeholder: _vm.$t("address.zipCodePlaceholder"),
                    },
                    model: {
                      value: _vm.form.receiverZipcode,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "receiverZipcode", $$v)
                      },
                      expression: "form.receiverZipcode",
                    },
                  }),
                  _c("van-field", {
                    staticClass: "px-3",
                    attrs: {
                      "label-width": "140",
                      label: _vm.$t("products.shippingAddress"),
                      placeholder: _vm.$t(
                        "products.shippingAddressPlaceholder"
                      ),
                    },
                    model: {
                      value: _vm.form.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "address", $$v)
                      },
                      expression: "form.address",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _c("van-field", {
            staticClass: "px-3",
            attrs: {
              "label-width": "140",
              label: _vm.$t("products.recipient"),
              placeholder: _vm.$t("products.recipientPlaceholder"),
            },
            model: {
              value: _vm.form.name,
              callback: function ($$v) {
                _vm.$set(_vm.form, "name", $$v)
              },
              expression: "form.name",
            },
          }),
          _c("van-field", {
            staticClass: "px-3",
            attrs: {
              "label-width": "120px",
              label: _vm.$t("address.phone"),
              placeholder: _vm.$t("address.phoneNumberPlaceholder"),
            },
            scopedSlots: _vm._u([
              {
                key: "input",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "flex-1 flex items-center justify-end" },
                      [
                        _c(
                          "div",
                          [
                            _c("van-field", {
                              staticClass: "p-0",
                              attrs: {
                                placeholder: _vm.$t(
                                  "address.countryCodePlaceholder"
                                ),
                                readonly: "",
                                "is-link": "",
                              },
                              on: {
                                "click-input": function ($event) {
                                  _vm.showCountryCodePopup = true
                                },
                              },
                              model: {
                                value: _vm.form.countryCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "countryCode", $$v)
                                },
                                expression: "form.countryCode",
                              },
                            }),
                          ],
                          1
                        ),
                        _c("van-field", {
                          staticClass: "p-0 w-44",
                          attrs: {
                            placeholder: _vm.$t(
                              "address.phoneNumberPlaceholder"
                            ),
                          },
                          model: {
                            value: _vm.form.mobile,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mobile", $$v)
                            },
                            expression: "form.mobile",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.form.mobile,
              callback: function ($$v) {
                _vm.$set(_vm.form, "mobile", $$v)
              },
              expression: "form.mobile",
            },
          }),
          _c("van-field", {
            staticClass: "px-3",
            attrs: {
              "label-width": "140",
              label: _vm.$t("products.emailAddress"),
              placeholder: "XXXX@gmail.com",
            },
            on: { input: _vm.handleEmailInput },
            model: {
              value: _vm.form.email,
              callback: function ($$v) {
                _vm.$set(_vm.form, "email", $$v)
              },
              expression: "form.email",
            },
          }),
          _c(
            "div",
            { staticClass: "px-3 py-2" },
            [
              _c(
                "van-checkbox",
                {
                  staticClass: "text-sm",
                  attrs: { "icon-size": "1rem", "checked-color": "#ff7a00" },
                  model: {
                    value: _vm.form.subscribeMarketing,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "subscribeMarketing", $$v)
                    },
                    expression: "form.subscribeMarketing",
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("products.subscribeMarketing")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
          !_vm.isLoggedIn
            ? _c("div", {}, [
                _vm.isZh && _vm.isRegister == false && _vm.form.email
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "tip-row flex items-center text-sm mb-1 px-3 py-2",
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("products.nonMember"))),
                        ]),
                        _c(
                          "van-button",
                          {
                            staticClass: "ml-1",
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              color: "#ff7a00",
                            },
                            on: { click: _vm.handleRegister },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("products.oneClickRegister")) +
                                " "
                            ),
                          ]
                        ),
                        _c("span", { staticClass: "ml-1" }, [
                          _vm._v(
                            _vm._s(_vm.$t("products.getRm5Coupon")) +
                              _vm._s(_vm.newReward || 0) +
                              _vm._s(_vm.$t("products.getRm5Coupon2"))
                          ),
                        ]),
                      ],
                      1
                    )
                  : !_vm.isZh && _vm.isRegister == false && _vm.form.email
                  ? _c(
                      "div",
                      { staticClass: "tip-row text-sm mb-1 px-3 py-2" },
                      [
                        _c("div", [
                          _vm._v(_vm._s(_vm.$t("products.nonMember"))),
                        ]),
                        _c(
                          "div",
                          { staticClass: "flex items-center" },
                          [
                            _c(
                              "van-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "mini",
                                  plain: "",
                                  color: "#ff7a00",
                                },
                                on: { click: _vm.handleRegister },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("products.oneClickRegister")
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                            _c("div", { staticClass: "ml-1" }, [
                              _vm._v(
                                _vm._s(_vm.$t("products.getRm5Coupon")) +
                                  _vm._s(_vm.newReward || 0) +
                                  _vm._s(_vm.$t("products.getRm5Coupon2"))
                              ),
                            ]),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm.isRegister && _vm.form.email
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "tip-row flex items-center text-sm px-3 py-2",
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("products.loginEarnCoins"))),
                        ]),
                        _c(
                          "van-button",
                          {
                            staticClass: "ml-1",
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              color: "#ff7a00",
                            },
                            on: { click: _vm.handleLogin },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("products.oneClickLogin")) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showCountryPopup,
            callback: function ($$v) {
              _vm.showCountryPopup = $$v
            },
            expression: "showCountryPopup",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.countryList },
            on: {
              confirm: _vm.onCountryConfirm,
              cancel: function ($event) {
                _vm.showCountryPopup = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showCityPopup,
            callback: function ($$v) {
              _vm.showCityPopup = $$v
            },
            expression: "showCityPopup",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.cityList },
            on: {
              confirm: _vm.onCityConfirm,
              cancel: function ($event) {
                _vm.showCityPopup = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showCountryCodePopup,
            callback: function ($$v) {
              _vm.showCountryCodePopup = $$v
            },
            expression: "showCountryCodePopup",
          },
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.countryCodeList },
            on: {
              confirm: _vm.onCountryCodeConfirm,
              cancel: function ($event) {
                _vm.showCountryCodePopup = false
              },
            },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function (slotProps) {
                  return [
                    _c("div", { staticClass: "flex items-center text-sm" }, [
                      _c("img", {
                        staticClass: "w-5 h-auto",
                        attrs: { src: slotProps.icon, alt: "" },
                      }),
                      _c("span", { staticClass: "ml-3" }, [
                        _vm._v(_vm._s(slotProps.text)),
                      ]),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }